// src/auth/LoginSuccess.jsx
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useAuthStore from '../stores/authStore';  // ← 追加

const resolveRedirectPath = (userType, nextParam) => {
  const safeNext = nextParam && nextParam.startsWith('/') ? nextParam : null;

  if (safeNext && safeNext !== '/') {
    return safeNext;
  }

  if (userType === 'system') return '/operator/dashboard';
  if (userType === 'admin') return '/operator/dashboard';
  if (userType === 'operator') return '/operator/dashboard';

  return '/enduser/taskmanagement';
};

export default function LoginSuccess() {  // ← props 削除
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { login } = useAuthStore();  // ← 追加

  useEffect(() => {
    try {
      const access = params.get('access');
      const refresh = params.get('refresh');
      const WuserName = params.get('name') || '';
      const WuserType = params.get('type') || 'enduser';
      const next = params.get('next') || '/';

      if (!access || !refresh) {
        navigate('/login?err=auth', { replace: true });
        return;
      }

      // ← 変更: authStore を使用
      login({ access, refresh, WuserName, WuserType });

      const redirectTo = resolveRedirectPath(WuserType, next);
      navigate(redirectTo, { replace: true });
    } catch (e) {
      navigate('/login?err=auth', { replace: true });
    }
  }, [navigate, params, login]);  // ← 依存配列変更

  return null;
}